import styled from 'styled-components';

import { IFooter } from './Footer';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 24px 24px 24px;
  background-color: ${({ theme }) => theme.colors.gray950};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
`;

export const RowContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const Title = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const Timer = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray0};

  span {
    font-size: 16px;

    :before {
      color: ${({ theme }) => theme.colors.gray0};
    }
  }
`;

export const ProgressContainer = styled.div`
  height: 8px;
  flex: 1;
  background-color: ${({ theme }) => theme.colors.gray700};
  border-radius: 8px;
  display: flex;
  position: relative;
`;

export const ProgressBar = styled.div`
  position: absolute;
  height: 8px;
  background: linear-gradient(220.53deg, #40ffaf 0%, #00b86b 76.95%);
  border-radius: 8px;
`;
